import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Header from "../header";
import Footer from "../footer.js";
import { Route, Switch } from "react-router-dom";
import { setBrand, setPlatform } from "../../../store/actions/form";
import { getFavicon, getPlatform } from "../../../helpers/layout";
import { gcnRoutes } from "../../../routes";
import * as paths from "../../../constants/paths";
import { GCN } from "../../../constants/label";

const Main = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const favicon = getFavicon();
        favicon.href = "/faviconGcn.ico";

        dispatch(setBrand(GCN));
        dispatch(setPlatform(getPlatform(window.location.href)));
        // eslint-disable-next-line
    }, []);

    return (
        <div>
            <Header />
            <Switch>
                {gcnRoutes(paths.subDomainFrance).map((route, key) =>
                    <Route
                        path={route.paths}
                        component={route.component}
                        key={key}
                    />)}
                {/* <Redirect to={paths.gcn_website_form(paths.layout)} /> */}
            </Switch>
            <Footer />
        </div>
    );
};

export default Main;
